import { useState } from "react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { MapPin, Clock, Users, ImageOff } from "lucide-react";
import { demoEvent } from "@/data/tourDemoData";

export const DemoEventCard = () => {
  const [imageError, setImageError] = useState(false);

  return (
    <Card className="w-full max-w-sm mx-auto overflow-hidden bg-card animate-scale-in">
      <div className="relative h-40">
        {imageError ? (
          <div className="w-full h-full bg-gradient-to-br from-primary/20 to-secondary/20 flex items-center justify-center">
            <div className="text-center text-muted-foreground">
              <ImageOff className="w-8 h-8 mx-auto mb-2 opacity-50" />
              <span className="text-xs">Event Image</span>
            </div>
          </div>
        ) : (
          <img 
            src={demoEvent.image} 
            alt={demoEvent.title}
            className="w-full h-full object-cover"
            onError={() => setImageError(true)}
          />
        )}
        <Badge className="absolute top-3 left-3 bg-primary/90 text-primary-foreground">
          {demoEvent.category}
        </Badge>
        <Badge className="absolute top-3 right-3 bg-green-500/90 text-white">
          FREE
        </Badge>
      </div>
      
      <div className="p-4 space-y-3">
        <h3 className="font-semibold text-lg text-foreground">{demoEvent.title}</h3>
        <p className="text-sm text-muted-foreground">Hosted by {demoEvent.host_name}</p>
        
        <div className="space-y-2 text-sm text-muted-foreground">
          <div className="flex items-center gap-2">
            <Clock className="w-4 h-4" />
            <span>{demoEvent.date} • {demoEvent.duration}</span>
          </div>
          <div className="flex items-center gap-2">
            <MapPin className="w-4 h-4" />
            <span>{demoEvent.location}</span>
          </div>
          <div className="flex items-center gap-2">
            <Users className="w-4 h-4" />
            <span>{demoEvent.attendees} going</span>
          </div>
        </div>
      </div>
    </Card>
  );
};
